import styled from '../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets } from '@indriver/vandermeer';
import preset from './preset.js';

var style = getPresets(preset, {
  textColor: 'design',
  backgroundColor: 'design',
  hoverAndPressedBackgroundColor: 'design',
  paddingLeftRight: 'size',
  gap: 'size',
  height: 'size',
  borderRadius: 'size',
  iconHeight: 'size',
  fontSize: 'size',
  fontLineHeight: 'size',
  outlineBorderRadius: 'size',
  prefixPostfixGap: 'size',
  prefixPostfixSize: 'size',
  minWidth: 'size',
  disabledBackground: 'design',
  disabledTextColor: 'design',
  paddingLeftRightGhost: 'size',
  heightGhost: 'size',
  hoverAndPressedColor: 'design',
  badgeLeftRight: 'size',
  badgeTop: 'size',
  alarmLeftRight: 'size',
  alarmTop: 'size'
});

var getBackground = function getBackground(props) {
  var disabledView = props.disabledView;

  if (disabledView) {
    return style.disabledBackground(props);
  }

  return style.backgroundColor(props);
};

var getBorderColor = function getBorderColor(props) {
  var focused = props.focused,
      disabledView = props.disabledView;

  if (focused) {
    return style.outlineBorderColor();
  }

  if (disabledView) {
    return style.disabledBackground(props);
  }

  return style.backgroundColor(props);
};

var getTextColor = function getTextColor(props) {
  var disabledView = props.disabledView;

  if (disabledView) {
    return style.disabledTextColor(props);
  }

  return style.textColor(props);
};

var getHoveredBackground = function getHoveredBackground(props) {
  var disabledView = props.disabledView,
      loadingView = props.loadingView;

  if (disabledView) {
    return style.disabledBackground(props);
  }

  if (loadingView) {
    return style.backgroundColor(props);
  }

  return style.hoverAndPressedBackgroundColor(props);
};

var getHoveredColor = function getHoveredColor(props) {
  var disabledView = props.disabledView;

  if (disabledView) {
    return style.disabledTextColor(props);
  }

  return style.hoverAndPressedColor(props);
};

var getHoveredBorderColor = function getHoveredBorderColor(props) {
  var disabledView = props.disabledView,
      loadingView = props.loadingView,
      focused = props.focused;

  if (disabledView) {
    return style.disabledBackground(props);
  }

  if (loadingView) {
    return style.backgroundColor(props);
  }

  if (focused) {
    return style.outlineBorderColor();
  }

  return style.hoverAndPressedBackgroundColor(props);
};

var getPaddingLeftRight = function getPaddingLeftRight(props) {
  var square = props.square,
      design = props.design;

  if (square) {
    return style.paddingLeftRightSquare(props);
  }

  if (design === 'ghost') {
    return style.paddingLeftRightGhost(props);
  }

  return style.paddingLeftRight(props);
};

var getHeight = function getHeight(props) {
  var design = props.design;

  if (design === 'ghost') {
    return style.heightGhost(props);
  }

  return style.height(props);
};

var LabelBox = /*#__PURE__*/styled("div")({
  name: "LabelBox",
  class: "lf6do54",
  vars: {
    "lf6do54-0": [function (_ref) {
      var loadingView = _ref.loadingView;
      return loadingView ? '0' : '1';
    }],
    "lf6do54-1": [style.prefixPostfixGap],
    "lf6do54-2": [function (_ref2) {
      var disabled = _ref2.disabled;
      return disabled ? 'none' : '1ms';
    }],
    "lf6do54-3": [style.fontLineHeight]
  }
});
var Label = /*#__PURE__*/styled("span")({
  name: "Label",
  class: "loaxzdy"
});

var getWidth = function getWidth(_ref3) {
  var stretched = _ref3.stretched,
      square = _ref3.square,
      size = _ref3.size;

  if (square) {
    return style.minWidth({
      size: size
    });
  }

  if (stretched) {
    return '100%';
  }

  return 'auto';
};

var Box = /*#__PURE__*/styled("button")({
  name: "Box",
  class: "b1en642a",
  vars: {
    "b1en642a-0": [getPaddingLeftRight],
    "b1en642a-1": [getHeight],
    "b1en642a-2": [style.borderRadius],
    "b1en642a-3": [getBackground],
    "b1en642a-4": [getTextColor],
    "b1en642a-5": [getBorderColor],
    "b1en642a-6": [function (_ref4) {
      var disabledView = _ref4.disabledView,
          loadingView = _ref4.loadingView;
      return disabledView || loadingView ? 'default' : 'pointer';
    }],
    "b1en642a-7": [function (_ref5) {
      var disabledView = _ref5.disabledView,
          loadingView = _ref5.loadingView;
      return disabledView || loadingView ? 'none' : 'auto';
    }],
    "b1en642a-8": [style.fontFamily],
    "b1en642a-9": [style.fontSize],
    "b1en642a-10": [style.fontLineHeight],
    "b1en642a-11": [style.minWidth],
    "b1en642a-12": [getWidth],
    "b1en642a-14": [getHoveredBackground],
    "b1en642a-15": [getHoveredBorderColor],
    "b1en642a-16": [getHoveredColor],
    "b1en642a-21": [function (_ref6) {
      var focused = _ref6.focused;
      return focused ? 'block' : 'none';
    }],
    "b1en642a-22": [style.outlineBorderRadius],
    "b1en642a-23": [style.outlineColor]
  }
});
var PrefixPostfix = /*#__PURE__*/styled("div")({
  name: "PrefixPostfix",
  class: "p1jxbf2q",
  vars: {
    "p1jxbf2q-0": [style.prefixPostfixSize]
  }
});
var LoadingBox = /*#__PURE__*/styled("div")({
  name: "LoadingBox",
  class: "lharb8i",
  vars: {
    "lharb8i-0": [style.prefixPostfixGap]
  }
});

var getNotificationRight = function getNotificationRight(_ref7) {
  var dir = _ref7.dir,
      size = _ref7.size,
      type = _ref7.type;
  return dir === 'ltr' ? type === 'Badge' ? style.badgeLeftRight({
    size: size
  }) : style.alarmLeftRight({
    size: size
  }) : 'auto';
};

var getNotificationLeft = function getNotificationLeft(_ref8) {
  var dir = _ref8.dir,
      size = _ref8.size,
      type = _ref8.type;
  return dir === 'rtl' ? type === 'Badge' ? style.badgeLeftRight({
    size: size
  }) : style.alarmLeftRight({
    size: size
  }) : 'auto';
};

var getNotificationTop = function getNotificationTop(_ref9) {
  var size = _ref9.size,
      type = _ref9.type;
  return type === 'Badge' ? style.badgeTop({
    size: size
  }) : style.alarmTop({
    size: size
  });
};

var Notification = /*#__PURE__*/styled("div")({
  name: "Notification",
  class: "nbs4ndg",
  vars: {
    "nbs4ndg-0": [getNotificationTop],
    "nbs4ndg-1": [getNotificationRight],
    "nbs4ndg-2": [getNotificationLeft]
  }
});

export { Box, Label, LabelBox, LoadingBox, Notification, PrefixPostfix };


require('../../styles-linaria/button/button.styles.css');
